import React from 'react'

export const ArrowLeft = ({ active }) => (
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path d="M6 11L1 6L6 1" stroke={active ? '#DE0C4B' : '#fff'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
